import PropTypes from "prop-types";
import { SettingsCard } from "top-component-library";
import { MAX_DESKTOP_BANNER_BYTES, MAX_MOBILE_BANNER_BYTES } from "../constants";
import ImageUploadField from "./ImageUploadField";

const MenuBannersCard = ({ mobileBannerUrl, desktopBannerUrl, onUpload, onDelete }) => (
  <SettingsCard title="Menu Banners">
    <div>
      <h4>Mobile Banner</h4>
      <ImageUploadField
        recommendation="Recommended ratio is 1.5/1 (width/height, e.g. 400px by 270px). Max 300 KB. Changes may take a few minutes to appear."
        accept={["image/*"]}
        maxSize={MAX_MOBILE_BANNER_BYTES}
        currentUrl={mobileBannerUrl}
        onUpload={(files) => onUpload("mobileBanner", files)}
        onDelete={() => onDelete("mobileBanner")}
      />
    </div>
    <div>
      <h4>Desktop Banner</h4>
      <ImageUploadField
        recommendation="Recommended ratio is 4/1. Max 1 MB. Changes may take a few minutes to appear."
        accept={["image/*"]}
        maxSize={MAX_DESKTOP_BANNER_BYTES}
        currentUrl={desktopBannerUrl}
        onUpload={(files) => onUpload("desktopBanner", files)}
        onDelete={() => onDelete("desktopBanner")}
      />
    </div>
  </SettingsCard>
);

MenuBannersCard.propTypes = {
  mobileBannerUrl: PropTypes.string,
  desktopBannerUrl: PropTypes.string,
  onUpload: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default MenuBannersCard;
